import React from "react";
import { motion } from "framer-motion";
import { Users, Sparkles, CheckCircle2 } from "lucide-react";

const AIWorkforceSlide = () => {
  return (
    <div className="h-full w-full bg-slate-50 flex flex-col items-center justify-center p-12 relative overflow-hidden font-sans">
      {/* Background */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-100/40 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-indigo-100/40 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2" />
      {/* Dot Pattern Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:32px_32px] opacity-60" />

      <div className="max-w-[1200px] w-full relative z-10 flex flex-col items-center justify-center h-full text-center">
        
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <div className="w-20 h-20 rounded-2xl bg-blue-600 flex items-center justify-center mx-auto shadow-xl mb-6">
            <Users className="w-10 h-10 text-white" />
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-8 leading-tight tracking-tight"
        >
          Asha's <span className="text-blue-600">AI</span> handles the
          <br />
          <span className="text-blue-600">work your staff</span> does today
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="text-xl md:text-2xl text-slate-500 font-medium max-w-3xl mb-10 leading-relaxed"
        >
          Answering calls, verifying insurance, submitting claims, posting payments, billing patients, recalling patients — 20 AI products doing the labor your staff spends hours on.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 max-w-3xl"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-14 h-14 rounded-xl bg-blue-100 flex items-center justify-center">
              <Sparkles className="w-8 h-8 text-blue-600" />
            </div>
            <div className="text-5xl font-black text-blue-600">20</div>
            <p className="text-2xl font-bold text-slate-700">AI Products</p>
          </div>

          <p className="text-2xl text-slate-700 font-semibold leading-relaxed">
            3-4 hours of staff work per patient, replaced by AI.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.8 }}
          className="flex items-center gap-3 mt-8 bg-blue-50 border border-blue-100 rounded-full px-6 py-3"
        >
          <span className="text-base text-blue-700 font-semibold">
            Previously: Asha's <span className="font-extrabold">software</span> replaces your 10+ softwares
          </span>
        </motion.div>
      </div>
    </div>
  );
};

export default AIWorkforceSlide;
